module.exports = __webpack_public_path__ + "media/images/avatar/development/parents/8-7218f5bd65dc78e93f1c44bbb11295c1.jpg";